"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var csod = require("player-core");
var View_1 = require("./View");
var MediaQueryContainer_1 = require("player-layout-controls/controls/MediaQueryContainer");
exports.LayoutControlsMediaQueryContainer = MediaQueryContainer_1.MediaQueryContainer;
var Flyout_1 = require("player-layout-controls/controls/Flyout");
exports.LayoutControlsFlyout = Flyout_1.Flyout;
var FlyoutTemplate_1 = require("player-common-composites/controls/FlyoutTemplate");
exports.CommonCompositesFlyoutTemplate = FlyoutTemplate_1.FlyoutTemplate;
var Panel_1 = require("player-layout-controls/controls/Panel");
exports.LayoutControlsPanel = Panel_1.Panel;
var GridLayout_1 = require("player-layout-controls/controls/GridLayout");
exports.LayoutControlsGridLayout = GridLayout_1.GridLayout;
var GridCol_1 = require("player-layout-controls/controls/GridCol");
exports.LayoutControlsGridCol = GridCol_1.GridCol;
var Text_1 = require("player-common-controls/controls/Text");
exports.CommonControlsText = Text_1.Text;
var Hyperlink_1 = require("player-common-controls/controls/Hyperlink");
exports.CommonControlsHyperlink = Hyperlink_1.Hyperlink;
var JobSearchFilter_1 = require("../JobSearchFilter/JobSearchFilter");
exports.JobSearchFilter = JobSearchFilter_1.JobSearchFilter;
var player_toggle_1 = require("player-toggle");
exports.Toggle = player_toggle_1.default;
var Button_1 = require("player-common-controls/controls/Button");
exports.CommonControlsButton = Button_1.Button;
var JobSearchFlyout = (function (_super) {
    __extends(JobSearchFlyout, _super);
    function JobSearchFlyout(props) {
        var _this = _super.call(this, props) || this;
        _this._setState = _this._setState.bind(_this);
        _this._proxyEvent = _this._proxyEvent.bind(_this);
        _this.forceRender = _this.forceRender.bind(_this);
        _this.view = View_1.view.call(_this, _this.props);
        _this.state = {
            viewModel: __assign({}, _this.view.state, _this.props),
            isInit: false
        };
        _this._trackers = {};
        if (typeof csod.context.tracking !== 'undefined') {
            var monikerCallback_1 = function (moniker, eventName) {
                var evt = document.createEvent("Event");
                evt.initEvent("player-" + moniker + "-" + eventName, true, false);
                window.dispatchEvent(evt);
            };
            for (var reporter in csod.context.tracking) {
                var _loop_1 = function (moniker) {
                    var events = csod.context.tracking[reporter][moniker];
                    var _loop_2 = function (i, l) {
                        var event_1 = events[i];
                        var monikerKey = moniker + '.' + event_1;
                        if (typeof this_1._trackers[monikerKey] === 'undefined')
                            this_1._trackers[monikerKey] = function () { monikerCallback_1(moniker, event_1); };
                    };
                    for (var i = 0, l = events.length; i < l; i++) {
                        _loop_2(i, l);
                    }
                };
                var this_1 = this;
                for (var moniker in csod.context.tracking[reporter]) {
                    _loop_1(moniker);
                }
            }
        }
        return _this;
    }
    JobSearchFlyout.prototype.componentDidMount = function () {
        var _this = this;
        this.view.initialize
            ? this.view.initialize(this.props)
                .then(function () {
                _this.view.mounted ? _this.view.mounted() : null;
                _this.setState({
                    isInit: true,
                    viewModel: __assign({}, _this.view.state, _this.props)
                });
            })
            : null;
    };
    JobSearchFlyout.prototype.componentWillReceiveProps = function (props) {
        var _this = this;
        this.view.receivedProps
            ? this.view.receivedProps(props).then(function () { return _this._setState(_this.state.viewModel, _this.view.state, props); })
            : this._setState(this.state.viewModel, this.view.state, props);
    };
    JobSearchFlyout.prototype.componentWillUnmount = function () {
        this.view.unmount ? this.view.unmount() : null;
    };
    JobSearchFlyout.prototype.forceRender = function (cb) {
        this.setState({
            viewModel: __assign({}, this.state.viewModel, this.view.state, this.props)
        }, cb ? cb : function () { });
    };
    JobSearchFlyout.prototype._setState = function (viewModel, viewState, props) {
        this.setState({ viewModel: __assign({}, viewModel, viewState, props) });
    };
    JobSearchFlyout.prototype._proxyTrackEvent = function (moniker, eventID, eventName) {
        var params = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            params[_i - 3] = arguments[_i];
        }
        var args = [];
        for (var i = 3; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        var monikerKey = moniker + '.' + eventID;
        var monikerCallback = this._trackers[monikerKey] || function () { };
        return this._procesEvent(eventName, args, 4, monikerCallback);
    };
    JobSearchFlyout.prototype._proxyEvent = function (eventName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var args = [];
        for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        return this._procesEvent(eventName, args, 2, function () { });
    };
    JobSearchFlyout.prototype._procesEvent = function (eventName, args, repeaterArgIndex, callback) {
        args = pushAndShiftArgs(args, repeaterArgIndex);
        if (typeof this.view.events[eventName] === 'function') {
            var self_1 = this;
            return function proxy() {
                var combinedArgs = [].slice.call(arguments).concat(args);
                var shouldRender = self_1.view.events[eventName].apply(self_1, combinedArgs);
                if (shouldRender !== false) {
                    csod.engine.commit();
                }
                csod.lastEventDate = new Date();
                callback();
            };
        }
        else {
            return function noFunc() {
                if (eventName) {
                    csod.logger.warn(eventName + ' is not a valid function. Please check for typos.');
                    csod.lastEventDate = new Date();
                }
                callback();
            };
        }
    };
    JobSearchFlyout.prototype.render = function () {
        var _this = this;
        var PlayerRepeater = csod.engine.controls.Player.Repeater;
        var PlayerVisible = csod.engine.controls.Player.Visible;
        var PlayerSwitch = csod.engine.controls.Player.Switch;
        var $this = this;
        var root_handler = function () {
            return [React.createElement(MediaQueryContainer_1.MediaQueryContainer, { key: 0, isVisible: true, isVisibleForMd: false, children: [React.createElement(Flyout_1.Flyout, { key: 0, isOpen: $this.state.viewModel.isOpen, size: "Large", onClose: _this._proxyEvent(""), children: [React.createElement(FlyoutTemplate_1.FlyoutTemplate, { key: 0, header: [React.createElement(Panel_1.Panel, { key: 0, children: [React.createElement(GridLayout_1.GridLayout, { key: 0, colMainAxisAlignment: "SpaceBetween", colCrossAxisAlignment: "Bottom", children: [React.createElement(GridCol_1.GridCol, { key: 0, children: [React.createElement(Text_1.Text, { key: 0, text: $this.state.viewModel.filtersText, size: "Xlarge", weight: "SemiBold" })] }), React.createElement(GridCol_1.GridCol, { key: 1, children: [React.createElement(Hyperlink_1.Hyperlink, { key: 0, text: $this.state.viewModel.resetText, type: "Action", onClick: _this._proxyEvent("onResetFilters"), children: [] })] })] })] })], children: [React.createElement(Panel_1.Panel, { key: 0, height: "100%", overflowY: "Auto", borderStyleTop: "Solid", borderWidthTop: "Xsmall", borderColorTop: "Grey70", children: [React.createElement(JobSearchFilter_1.JobSearchFilter, { key: 0, filters: $this.state.viewModel.filters, handleCollapsibleClick: _this._proxyEvent("handleCollapsibleClick"), onRadioButtonClick: _this._proxyEvent("handleRadioButtonClick"), onCheckboxClick: _this._proxyEvent("handleCheckboxClick"), onInputChange: _this._proxyEvent("handleInputChange"), onDropdownSelect: _this._proxyEvent("handleDropdownSelect") }), React.createElement(PlayerVisible, { key: 1, visible: $this.state.viewModel.showMobile.showFilter, children: [React.createElement(Panel_1.Panel, { key: 0, paddingAll: "Medium", children: [React.createElement(player_toggle_1.default, { key: 0, label: $this.state.viewModel.showMobile.labelText, showLabel: true, checked: $this.state.viewModel.showMobile.isChecked, onChange: _this._proxyEvent("onShowMobileChecked") })] })] })] })], footer: [React.createElement(GridLayout_1.GridLayout, { key: 0, colMainAxisAlignment: "SpaceBetween", children: [React.createElement(GridCol_1.GridCol, { key: 0, children: [React.createElement(Button_1.Button, { key: 0, text: $this.state.viewModel.cancelText, color: "Grey", onClick: _this._proxyEvent("onFilterCancel") })] }), React.createElement(GridCol_1.GridCol, { key: 1, children: [React.createElement(Button_1.Button, { key: 0, text: $this.state.viewModel.applyText, onClick: _this._proxyEvent("onFilterApply") })] })] })] })] })] })];
        };
        return (React.createElement("div", { className: "p-view-jobsearchflyout" }, this.state.isInit ? root_handler() : null));
    };
    return JobSearchFlyout;
}(React.Component));
JobSearchFlyout.defaultProps = {
    isOpen: "", applyText: "", cancelText: "", filters: "", filtersText: "", resetText: "", showMobile: "", onFilterApply: function () { }, onFilterCancel: function () { }, handleCollapsibleClick: function () { }, onRadioButtonClick: function () { }, onCheckboxClick: function () { }, onInputChange: function () { }, onDropdownSelect: function () { }, onShowMobileChecked: function () { }, onResetFilters: function () { }
};
exports.JobSearchFlyout = JobSearchFlyout;
function pushAndShiftArgs(args, repeaterArgIndex) {
    if (args[repeaterArgIndex] === 'repeaterArgs') {
        args.push(args.shift());
        args.push(args.shift());
        args.shift();
        pushAndShiftArgs(args, repeaterArgIndex);
    }
    return args;
}
if (!window["__LOCALES__"])
    window["__LOCALES__"] = {};
window["__LOCALES__"]["JobSearchFlyout"] = [];



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/.tmp/JobSearchFlyout/JobSearchFlyout.js
// module id = 751
// module chunks = 0